var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loggedIn
    ? _c("div", { staticClass: "hl-wid ww4 welcome-page-container" }, [
        _c("div", { staticClass: "welcome-page" }, [
          _c("a", {
            staticClass: "register",
            attrs: { href: "" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.doLogin($event)
              }
            }
          })
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }